import { React, useState, useEffect } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import { Button, Form, Input, Row, Col, Table, Modal, Image, Select, Upload, Skeleton, Spin } from 'antd';
import { HttpHandler } from '../../shared/httpHandler';
import { EditOutlined, DeleteOutlined, RocketOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import secureStorage from '../../shared/secureStorage';

const httpHandler = new HttpHandler();

const ShowRoomMaintenance = () => {
    const [carSearchForm] = Form.useForm();
    const [carEditForm] = Form.useForm();
    const [carTableData, setCarTableData] = useState([]);
    const [carTableParams, setCarTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [loading, setLoading] = useState(false);
    const [selectedCar, setSelectedCar] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentEditType, setCurrentEditType] = useState("");
    const handleTableChange = (pagination, filters, sorter) => {
        setCarTableParams({
            pagination,
            filters,
            ...sorter,
        });
        getCarData(pagination);
    };

    const searchCarData = async () => {
        setCarTableParams({
            ...carTableData,
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        getCarData({
            current: 1,
            pageSize: 10,
        });
    }

    const getCarData = async (pagination = carTableParams.pagination) => {
        let { carType, name, isCancel } = carSearchForm.getFieldsValue();
        carType = carType ? carType : '';
        name = name ? name : '';
        isCancel = isCancel ?? "0";

        const { current, pageSize } = pagination;
        // console.log('sendingTime:', sendingTime);

        setLoading(true);
        httpHandler.get(`/show_room_maintenance/get_show_room_data?car_type=${carType}&name=${name}&is_cancel=${isCancel}&current=${current}&page_size=${pageSize}`)
            .then((response) => {
                if (response.success) {
                    setCarTableData(response.data);
                    setCarTableParams({
                        ...carTableData,
                        pagination: {
                            ...pagination,
                            total: response.total,
                        },
                    });
                } else {
                    window.antdNotify('錯誤', response.data.message, 'fail');
                }
                setLoading(false);
            });
    }

    const CarSearchBar = () => {
        return (
            <Form form={carSearchForm}
                name="carSearchForm"
                onFinish={searchCarData}
                initialValues={{ isCancel: 0 }}
            >
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="車型名稱" name="carType">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="車款名稱" name="name">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="啟用狀態" name="isCancel">
                            <Select>
                                <Select.Option value="">全部</Select.Option>
                                <Select.Option value={0}>啟用中</Select.Option>
                                <Select.Option value={1}>非啟用</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={16} className="button-group">
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                setCurrentEditType("新增車款展示間");
                                setIsModalVisible(true);
                            }}
                            className="button button--register">
                            新增
                        </Button>
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            htmlType="submit"
                            className="button button--search">
                            搜尋
                        </Button>
                    </Col>
                </Row>
            </Form >
        )
    }

    const CarDataTable = () => {
        const columns = [
            {
                title: '編輯',
                key: 'editCar',
                render: (text, record) => {
                    return (
                        <Button
                            type="primary"
                            icon={<EditOutlined />}
                            onClick={() => {
                                setSelectedCar(record);
                                setCurrentEditType("編輯車款展示間");
                                carEditForm.setFieldsValue(record);
                                setIsModalVisible(true);
                            }}
                        >
                            編輯車款
                        </Button>
                    );
                },
            },
            {
                title: '車款照片 url',
                dataIndex: 'img_path',
                key: 'img_path',
                render: (text) => {
                    return <img src={text} alt="圖片" style={{ width: '100px' }} />;
                },
            },
            {
                title: '車型名稱',
                dataIndex: 'car_type',
                key: 'carType',
            },
            {
                title: '車款名稱',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '車款高度',
                dataIndex: 'height',
                key: 'height',
            },
            {
                title: '車款寬度',
                dataIndex: 'width',
                key: 'width',
            },
            {
                title: '車款長度',
                dataIndex: 'length',
                key: 'length',
            },
            {
                title: '車款價格',
                dataIndex: 'price',
                key: 'price',
            },
            {
                title: '車款展示網址',
                dataIndex: 'show_room_url',
                key: 'show_room_url',
            },
            {
                title: '車款預約網址',
                dataIndex: 'booking_url',
                key: 'booking_url',
            },
            {
                title: '狀態',
                dataIndex: 'is_cancel',
                key: 'is_cancel',
                render: (text) => {
                    return text === 0 ? "啟用中" : "非啟用";
                },
            },

        ]

        return (
            <div>
                <Table
                    columns={columns}
                    loading={loading}
                    dataSource={carTableData}
                    pagination={carTableParams.pagination}
                    scroll={{ x: 'max-content' }}
                    onChange={handleTableChange}
                />
            </div>
        );
    }

    const handleModalOnFinish = () => {
        searchCarData()
        setIsModalVisible(false);
        setSelectedCar({});
        setCurrentEditType("");
        carEditForm.resetFields();
    }

    const handleModalOnCancel = () => {
        setIsModalVisible(false);
        setSelectedCar({});
        setCurrentEditType("");
        carEditForm.resetFields();
    }

    const EditModal = () => {

        const showConfirm = () => {
            const submitData = carEditForm.validateFields()
                .then((values) => {
                    Modal.confirm({
                        title: `確認${currentEditType}`,
                        content: `你確定要儲存這些變更嗎？`,
                        okText: '確定',
                        cancelText: '取消',
                        onOk() {
                            editModalSubmitHandler();
                            setIsModalVisible(false);
                        },
                        onCancel() {
                            console.log('取消儲存');
                        },
                    });
                })
                .catch((errorInfo) => {
                    console.log('Validation failed:', errorInfo);
                    return null;
                });
            // console.log('submitData:', submitData);

        };


        return (

            <Modal
                width="50%"
                title={`${currentEditType}`}
                visible={isModalVisible}
                onCancel={() => {
                    handleModalOnCancel();
                }}
                footer={[
                    <Button
                        key="close"
                        onClick={() => {
                            handleModalOnCancel();
                        }}
                    >
                        關閉
                    </Button>,
                    <Button
                        key="save"
                        type="primary"
                        onClick={() => {
                            showConfirm();
                        }}
                    >
                        儲存
                    </Button>,
                ]}
            >

                <Form
                    form={carEditForm}
                    name="carEditForm"
                >
                    <Form.Item label="車型名稱" name="car_type" rules={[{ required: true, message: '請輸入車型名稱' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="車款名稱" name="name" rules={[{ required: true, message: '請輸入車款名稱' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="車款照片 url" name="img_path">
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="車款高度" name="height" rules={[{ required: true, message: '請輸入車款高度' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="車款寬度" name="width" rules={[{ required: true, message: '請輸入車款寬度' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="車款長度" name="length" rules={[{ required: true, message: '請輸入車款長度' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="車款價格" name="price" rules={[{ required: true, message: '請輸入車款價格' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="車款展示網址" name="show_room_url" rules={[{ required: true, message: '請輸入車款展示網址' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="車款預約網址" name="booking_url" rules={[{ required: true, message: '請輸入車款預約網址' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="狀態" name="is_cancel" rules={[{ required: true, message: '請選擇狀態' }]}>
                        <Select>
                            <Select.Option value={0}>啟用中</Select.Option>
                            <Select.Option value={1}>非啟用</Select.Option>
                        </Select>
                    </Form.Item>
                </Form>


            </Modal>

        );
    };

    const editModalSubmitHandler = async () => {
        // console.log('apiLoading', apiLoading);

        const submitData = carEditForm.getFieldsValue();

        // console.log('submit_submitData:', submitData);


        if (currentEditType === "新增車款展示間") {

            // console.log('submitData:', submitData);

            const postData = {
                "car_type": submitData.car_type,
                "height": Number(submitData.height),
                "show_room_url": btoa(submitData.show_room_url),
                "booking_url": btoa(submitData.booking_url),
                "name": submitData.name,
                "img_path": btoa(submitData.img_path),
                "price": Number(submitData.price),
                "length": Number(submitData.length),
                "width": Number(submitData.width),
                "is_cancel": Number(submitData.is_cancel),
                "cancel_user": submitData.is_cancel === 1 ? secureStorage.getItem('userId') : null,
                "create_user": secureStorage.getItem('userId'),
            }
            // console.log('postData:', postData);
            httpHandler.post('/show_room_maintenance/insert_show_room_data', postData).then((response) => {
                if (response.success) {
                    window.antdNotify('成功', '新增車款展示間成功', 'success');
                    handleModalOnFinish();
                } else {
                    window.antdNotify('錯誤', response.message, 'fail');
                }
            });
        } else if (currentEditType === "編輯車款展示間") {

            const postData = {
                "id": selectedCar.id,
                "car_type": submitData.car_type,
                "height": Number(submitData.height),
                "show_room_url": btoa(submitData.show_room_url),
                "booking_url": btoa(submitData.booking_url),
                "name": submitData.name,
                "img_path": btoa(submitData.img_path),
                "price": Number(submitData.price),
                "length": Number(submitData.length),
                "width": Number(submitData.width),
                "is_cancel": Number(submitData.is_cancel),
                "cancel_user": submitData.is_cancel === 1 ? secureStorage.getItem('userId') : null,
                "update_user": secureStorage.getItem('userId'),
            }
            // console.log('postData:', postData);
            httpHandler.post('/show_room_maintenance/update_show_room_data', postData).then((response) => {
                if (response.success) {
                    window.antdNotify('成功', '編輯車款展示間成功', 'success');
                    handleModalOnFinish();
                } else {
                    window.antdNotify('錯誤', response.message, 'fail');
                }
            });
        }

    }

    const section = [
        {
            hasTitle: false,
            title: 'Search',
            children: <CarSearchBar />,
        },
        {
            hasTitle: false,
            title: 'Search',
            children: <CarDataTable />,
        },
        {
            hasTitle: false,
            title: 'Edit and Modal',
            children: <EditModal loading={loading} />,
        },
    ];

    useEffect(() => {
        getCarData();
    }, []);


    return (
        <>
            <PageHeader functionName={'lexus_show_room'}></PageHeader>
            <PageBody section={section}></PageBody>
        </>
    );
}

export default ShowRoomMaintenance;